var React = require('react');

function InformationInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.66658 13.5733V18.9067L14.9999 24L24.3333 18.9067V13.5733L14.9999 18.6667L5.66658 13.5733ZM14.9999 0L0.333252 8L14.9999 16L26.9999 9.45333V18.6667H29.6666V8L14.9999 0Z","fill":"#1B2B4C"}));
}

InformationInline.defaultProps = {"width":"30","height":"24","viewBox":"0 0 30 24","fill":"none"};

module.exports = InformationInline;

InformationInline.default = InformationInline;
